import { CardContainer } from "@/components/commons/CardContainer";
import { STATUS_LABEL } from "@/constants/enum";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Select } from "@/components/elements/Select";
import { useEnum } from "@/api/services/global/enum";
import { TSubjectCreateForm } from "@/features/learning-content/types/learningContent";
import { Box, Grid, Stack, Typography, styled } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

type TBasicInfoFormProps = {};

// Basic information form section for subject creation
export const BasicInfoForm: FC<TBasicInfoFormProps> = () => {
  const { control, watch } = useFormContext<TSubjectCreateForm>();
  const { data: partTypeOptions } = useEnum("EPartType");
  const status = watch("status");
  const activationDate = watch("activationDate");

  return (
    <CardContainer sx={{ borderRadius: "8px" }}>
      <Stack gap={3}>
        <Typography variant="sub16Bold" sx={{ fontSize: "20px", fontWeight: 700 }}>
          基本情報
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <FormField control={control} name="subjectName">
              <Input fullWidth placeholder="入力してください" />
            </FormField>
          </Grid>

          {/* パート */}
          <Grid item xs={3}>
            <FormField control={control} name="sectionDivision">
              <Select fullWidth options={partTypeOptions} placeholder="選択してください" />
            </FormField>
          </Grid>

          {/* ステータス (read-only) */}
          <Grid item xs={2}>
            <Typography variant="body14" sx={{ color: "text.secondary", fontSize: "12px" }}>
              ステータス
            </Typography>
            <ReadOnlyField>
              <Typography variant="body14" sx={{ color: "text.primary" }}>
                {status || STATUS_LABEL.DISABLED}
              </Typography>
            </ReadOnlyField>
          </Grid>

          {/* 有効化日 (read-only) */}
          <Grid item xs={2}>
            <Typography variant="body14" sx={{ color: "text.secondary", fontSize: "12px", mb: 0.5 }}>
              有効化日
            </Typography>
            <ReadOnlyField>
              <Typography variant="body14" sx={{ color: "text.primary" }}>
                {activationDate || "--/--/--"}
              </Typography>
            </ReadOnlyField>
          </Grid>
        </Grid>

        {/* 社内メモ */}
        <FormField control={control} name="internalNote">
          <Input fullWidth placeholder="入力してください" />
        </FormField>
      </Stack>
    </CardContainer>
  );
};

const ReadOnlyField = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  min-height: 30px;
  display: flex;
  align-items: center;
`;
